import _ from 'lodash';

export class GridData {
  constructor(state) {
    this._init(state);
  }

  _init(state) {
    const {data, groups, category, columns} = state;
    const dataSource = {
      data,
      pageSize: 20
    };

    if (groups) {
      const field = _.find(columns, c =>
          _.snakeCase(c.title) === _.snakeCase(groups.value)
      ).field;

      dataSource.sort = {field, dir: 'desc'};
    }

    this.dataSource = dataSource;
    this.columns = _.filter((category ? [category].concat(columns) : columns), column => !column.hidden);
    this.type = 'grid';
  }
}
